// extracted by mini-css-extract-plugin
export default {"peplogo":"Header_peplogo__HbQzB","pepsiLogoCls":"Header_pepsiLogoCls__IjhiZ"};